import { render, staticRenderFns } from "./MyViewer.vue?vue&type=template&id=7b18a6bd&scoped=true&"
import script from "./MyViewer.vue?vue&type=script&lang=js&"
export * from "./MyViewer.vue?vue&type=script&lang=js&"
import style0 from "./MyViewer.vue?vue&type=style&index=0&id=7b18a6bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b18a6bd",
  null
  
)

export default component.exports